<template>
  <img alt="alt" class="hero-padrao" />
  <section class="hero-carousel">
    
    <div class="carousel-container">
      <div class="hero-slide">
        <picture>
          <source media="(min-width: 768px)" :srcset="desktopSrc" />
          <img :src="mobileSrc" :alt="alt" class="hero-img" />
        </picture>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  desktopSrc: { type: String, required: true },
  mobileSrc: { type: String, required: true },
  alt: { type: String, default: "Banner Click Sorvetes" },
  destaque: { type: String, default: "" },
  titulo: { type: String, required: true },
  subtitulo: { type: String, default: "" },
  ctaTexto: { type: String, default: "Saiba mais" },
  ctaLink: { type: String, default: "/contato" },
});
</script>

<style scoped>
/* ==========================================================
   HERO RESPONSIVO — ALINHADO AO PADRÃO GLOBAL
   ========================================================== */
.hero-carousel {
  position: relative;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  margin: 80px 0;
}

/* container mantém padrão do global.css */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.hero-slide {
  flex: 0 0 100%;
  position: relative;
}

/* imagem full sem empurrar conteúdo */
.hero-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  object-position: center;
}

/* ==========================================================
   OVERLAY
   ========================================================== */
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(0, 0, 0, 0.4) 40%,
    rgba(0, 0, 0, 0.1) 100%
  );
  z-index: 2;
}

/* ==========================================================
   TEXTO E BOTÃO
   ========================================================== */
.hero-content {
  position: absolute;
  z-index: 3;
  color: #fff;
  padding: 1.8rem;
  bottom: 6%;
  left: 8%;
  right: 8%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: flex-end;
}

.hero-title {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  max-width: 600px;
}
.hero-title span {
  color: #ff5384;
}

.hero-subtitle {
  font-size: 1rem;
  color: #ffd852;
  line-height: 1.5;
  max-width: 480px;
}

.hero-btn {
  display: inline-block;
  background: linear-gradient(90deg, #ff5384, #ffd852);
  color: #222;
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.25s ease;
  margin-top: 0.8rem;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  width: fit-content;
}
.hero-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

/* ==========================================================
   RESPONSIVIDADE — INTEGRADA AO PADRÃO GLOBAL
   ========================================================== */

/* Mobile */
@media (max-width: 768px) {
  .hero-content {
    text-align: center;
    align-items: center;
    bottom: 5%;
    left: 0;
    right: 0;
  }

  .hero-title {
    font-size: 1.6rem;
    max-width: 90%;
  }

  .hero-subtitle {
    font-size: 0.95rem;
    max-width: 90%;
  }

  .hero-btn {
    align-self: center;
  }
  .hero-carousel {
 
  margin: 40px 0;
}
}

/* Desktop — respeita centralização do .container global */
@media (min-width: 1024px) {
  .hero-content {
    left: calc((100vw - 1200px) / 2);
    right: auto;
  }

  .hero-title {
    font-size: 2.2rem;
  }

  .hero-subtitle {
    font-size: 1.05rem;
  }
}
</style>
